<template>
  <v-menu
    :ref="name"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <ValidationProvider :vid="name" :name="label"
        :mode="validationMode" :rules="rules" v-slot="{ errors }">
        <v-text-field
          :id="name"
          autocomplete="off"
          :ref="name"
          v-model="formated"
          :data-vv-as="name"
          :label="label"
          :hint="hint"
          :persistent-hint="persistentHint"
          :placeholder="placeholder"
          append-icon="mdi-clock"
          outlined dense
          v-mask="'##:##'"
          @blur="blur"
          v-on="on"
          :error="errors.length > 0"
          :error-messages="errors[0]"
        ></v-text-field>
      </ValidationProvider>
    </template>
    <v-time-picker
      v-model="internalValue"
      @input="menu = false"
      :min="min" :max="max"
      format="24hr" locale="pt-br"
    ></v-time-picker>
  </v-menu>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { mask } from 'vue-the-mask';

export default {
  directives: { mask },
  props: {
    value: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    validationMode: {
      type: String,
      default: 'lazy',
    },
    hint: {
      type: String,
    },
    label: {
      type: String,
    },
    persistentHint: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    min: {
      type: String,
    },
    max: {
      type: String,
    },
    rules: {
      type: [String, Object],
    },
  },
  created() {
    this.formated = '';
    if (this.value) {
      this.internalValue = this.value;
      this.formated = this.parse(this.value);
    }
  },
  data: () => ({
    menu: false,
    internalValue: null,
    formated: '',
    time: null,
  }),
  computed: {
    computedformated() {
      return this.format(this.time);
    },
  },
  methods: {
    blur() {
      this.internalValue = this.parse(this.formated);
      this.$emit('input', this.internalValue);
    },
    format(time) {
      if (!time) return null;
      return this.$moment(time, 'HH:mm').format('HH:mm');
    },
    parse(time) {
      if (!time) return null;
      return this.$moment(time, 'HH:mm').format('HH:mm');
    },
  },
  watch: {
    internalValue() {
      this.formated = this.format(this.internalValue);
      this.$emit('input', this.internalValue);
    },
    value(vl) {
      this.internalValue = vl;
      this.formated = this.format(this.internalValue);
    },
  },
  components: {
    ValidationProvider,
  },
};
</script>
